export const SENTRY_CONFIG = {
  DSN: 'https://7fc7f751d8a616e7b3c2bc8986a2ab7c@o4505090423521280.ingest.us.sentry.io/4510509824671744',
  ALLOW_ORIGIN: ['localhost', /^https:\/\/v-comply\.com/],
  TRACES_SAMPLE_RATE: 1.0,
  REPLAY_SESSION_SAMPLE_RATE: 0.1,
  REPLAY_ON_ERROR_SAMPLE_RATE: 1.0,
};
